module.exports = __webpack_public_path__ + "static/media/9.38b4d2ed.jpg";